export class Loading<T> {
  resolved: T | null = null
  promise: Promise<T>
  done = (_val: T) => {}
  hasSettled = false

  constructor() {
    this.promise = new Promise((resolve) => {
      this.done = resolve
    })
    this.promise.then((val) => {
      this.resolved = val
      this.hasSettled = true
    })
  }
}
